import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from './globals';
import { EmailTrigger } from 'app/models/email-trigger';

@Injectable({
  providedIn: 'root',
})
export class EmailTriggerService {
  private readonly endpoint: string;

  constructor(private http: HttpClient, private globals: Globals) {
    this.endpoint = `${this.globals.api_base_url}/email-triggers`;
  }

  // Get all email triggers
  getAll(): Observable<EmailTrigger[]> {
    return this.http.get<EmailTrigger[]>(this.endpoint);
  }

  // Get a single email trigger by ID
  getById(id: number): Observable<EmailTrigger> {
    return this.http.get<EmailTrigger>(`${this.endpoint}/${id}`);
  }

  // Create a new email trigger
  create(emailTrigger: EmailTrigger): Observable<EmailTrigger> {
    return this.http.post<EmailTrigger>(this.endpoint, emailTrigger);
  }

  // Update an existing email trigger
  update(id: number, emailTrigger: EmailTrigger): Observable<EmailTrigger> {
    return this.http.put<EmailTrigger>(`${this.endpoint}/${id}`, emailTrigger);
  }

  // Delete an email trigger by ID
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${id}`);
  }
}
